const indexItems = [
  { title: '最新电影', count: '2,386部', icon: 'ri-film-line' },
  { title: '热门电视剧', count: '1,952部', icon: 'ri-tv-2-line' },
  { title: '综艺节目', count: '856档', icon: 'ri-live-line' },
  { title: '动漫番剧', count: '3,120部', icon: 'ri-ghost-line' },
  { title: '纪录片', count: '648部', icon: 'ri-earth-line' },
  { title: '动作片', count: '1,203部', icon: 'ri-fire-line' },
  { title: '喜剧片', count: '892部', icon: 'ri-emotion-laugh-line' },
  { title: '悬疑推理', count: '679部', icon: 'ri-search-eye-line' },
];

export default function IndexSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="index" className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">分类索引</h2>
            <p className="text-sm text-gray-500 mt-2">按类型快速发现你感兴趣的内容</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {indexItems.map((item, idx) => (
              <a
                key={idx}
                href="#cards"
                onClick={(e) => handleNavClick(e, '#cards')}
                className="group bg-gray-50 hover:bg-brand-50 rounded-xl p-5 border border-gray-100 hover:border-brand-200 transition-all duration-300 cursor-pointer no-underline"
              >
                <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center mb-3 group-hover:bg-brand-100 transition-colors duration-300">
                  <i className={`${item.icon} text-brand-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-sm font-bold text-gray-800 group-hover:text-brand-700 transition-colors duration-300 mb-1">{item.title}</h3>
                <span className="text-xs text-gray-400 whitespace-nowrap">{item.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}